let transferIndex = 1010

function transferIncrease() {
    transferIndex++
}

export {transferIndex, transferIncrease}